"use strict";
exports.__esModule = true;
var EvaluationDetails_1 = require("./EvaluationDetails");
var ConfigEvaluation = /** @class */ (function () {
    function ConfigEvaluation(value, rule_id, group_name, secondary_exposures, json_value, explicit_parameters, config_delegate, configVersion, unsupported) {
        if (rule_id === void 0) { rule_id = ''; }
        if (group_name === void 0) { group_name = null; }
        if (secondary_exposures === void 0) { secondary_exposures = []; }
        if (json_value === void 0) { json_value = {}; }
        if (explicit_parameters === void 0) { explicit_parameters = null; }
        if (config_delegate === void 0) { config_delegate = null; }
        if (unsupported === void 0) { unsupported = false; }
        this.value = value;
        this.rule_id = rule_id;
        if (typeof json_value === 'boolean') {
            // handle legacy gate case
            this.json_value = {};
        }
        else {
            this.json_value = json_value;
        }
        this.secondary_exposures = secondary_exposures;
        this.undelegated_secondary_exposures = secondary_exposures;
        this.config_delegate = config_delegate;
        this.unsupported = unsupported;
        this.explicit_parameters = explicit_parameters;
        this.is_experiment_group = false;
        this.group_name = group_name;
        this.configVersion = configVersion;
    }
    ConfigEvaluation.prototype.withEvaluationDetails = function (evaulationDetails) {
        this.evaluation_details = evaulationDetails;
        return this;
    };
    ConfigEvaluation.prototype.setIsExperimentGroup = function (isExperimentGroup) {
        if (isExperimentGroup === void 0) { isExperimentGroup = false; }
        this.is_experiment_group = isExperimentGroup;
    };
    ConfigEvaluation.unsupported = function (configSyncTime, initialUpdateTime, version) {
        return new ConfigEvaluation(false, '', null, [], {}, undefined, undefined, version, true).withEvaluationDetails(EvaluationDetails_1.EvaluationDetails.unsupported(configSyncTime, initialUpdateTime));
    };
    return ConfigEvaluation;
}());
exports["default"] = ConfigEvaluation;
